import script from "./InvitationSeatMap.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationSeatMap.vue?vue&type=script&setup=true&lang=js"

import "./InvitationSeatMap.vue?vue&type=style&index=0&id=1b95b37f&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b95b37f"]])

export default __exports__